import { GET_TIPO_MOV_REDEM, ADD_TIPO_MOV_REDEM, MODIFY_TIPO_MOV_REDEM, DELETE_TIPO_MOV_REDEM, UPDATE_TIPO_MOV_REDEM } from '../constants/action_types';

const initialState = {
    tipoMovRedemList: [],
    isLoading: false
};

export default function (state = initialState, action) {


    switch (action.type) {
        case GET_TIPO_MOV_REDEM:
            
            return {
                ...state,
                isLoading: true
            };

        case GET_TIPO_MOV_REDEM + "_SUCCESS":
            return {
                tipoMovRedemList: action.payload.data,
                isLoading: false
            };

        case ADD_TIPO_MOV_REDEM:
            
            const newArr = [...state.tipoMovRedemList, action.payload]
            return {
                tipoMovRedemList: newArr,
                isLoading: false
            };

        case MODIFY_TIPO_MOV_REDEM:
            
            return {
                tipoMovRedemList: state.tipoMovRedemList.map((p) => {
                    if (p.id !== action.payload.id) 
                        return p;
                    else
                        return action.payload
                }),
                isLoading: false
            };

        case DELETE_TIPO_MOV_REDEM:

            return {
                tipoMovRedemList: state.tipoMovRedemList.filter(p => p.id !== action.payload.id),
                isLoading: false
            };

        case UPDATE_TIPO_MOV_REDEM + "_SUCCESS":

            return state;

        default:

            return state;
    }
}